import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import moment from "moment";
import { Link } from "react-router-dom";
import { FETCH_PRODUCTION_PLAN_LOGS } from "./graphql";

const PlanLogsView = ({ planId }) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCTION_PLAN_LOGS, {
    variables: { id: planId },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <div className="text-sm">
      <div className="-mx-2">
        <table>
          <thead>
            <tr>
              <th>Datetime</th>
              <th>User</th>
              <th>Operation</th>
              <th>Start Date</th>
              <th>Ready Date</th>
              <th>Effected by Plan</th>
            </tr>
          </thead>
          <tbody>
            {data.productionPlan.logs.map((i) => (
              <tr key={i.id} className="border-y dark:border-gray-700">
                <td>{moment(i.createdAt).format("YYYY-MM-DD hh:mm:ss")}</td>
                <td>{i.user.firstName}</td>
                <td>{i.operation}</td>
                <td>{moment(i.startDate).format("YYYY-MM-DD")}</td>
                <td>{moment(i.readyDate).format("YYYY-MM-DD")}</td>
                <td>
                  {i.effectedByPlan ? (
                    <Link
                      to={`/order-scheduler/plans/${i.effectedByPlan.id}`}
                      target="_blank"
                    >
                      {i.effectedByPlan.name}
                    </Link>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlanLogsView;
